import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center mt-4" }
const _hoisted_2 = { style: {"border-bottom":"2px solid rgb(21, 130, 156)","width":"98%"} }
const _hoisted_3 = { class: "d-flex fw-bold mb-2 justify-content-center" }
const _hoisted_4 = { class: "modal-body mx-4 mt-4" }
const _hoisted_5 = { class: "w-100 d-flex justify-space-between mt-4 mb-6" }
const _hoisted_6 = { class: "modal-footer m-3 mt-2" }

import { ref, computed, watch } from 'vue'
import { GDialog } from 'gitart-vue-dialog';
import DisplayFailedList from "@/components/DailyReportParts/DisplayFailedList.vue";
import CopyButton from "@/components/Common/CopyButton.vue"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'FailedTripIdsModal',
  props: {
    state: { type: Boolean },
    modalDisplayData: {},
    message: {},
    operationOfficeName: {}
  },
  emits: ['closeModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modalTitle = i18n.global.t('pages.dailyReports.failedTripIdsModal.tripIdList') as string
const localState = ref(false as boolean)
const closeBtnName = i18n.global.t('pages.common.button.close') as string
const isCopied = ref(true as boolean)
const operationOfficeNameLabel = i18n.global.t('pages.dailyReports.failedTripIdsModal.operationOfficeName') as string

const copyedValue = computed(() => {
  let copyedValue = ""
  copyedValue = `${operationOfficeNameLabel}${props.operationOfficeName}\n`
  props.modalDisplayData.forEach((tripId) => {
    copyedValue += `${tripId}\n`
  })
  return copyedValue
})

function close() {
  emits("closeModal", false)
}

watch(() => props.state, (bool) => {
  localState.value = bool
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    modelValue: localState.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localState).value = $event)),
    "max-width": "45%",
    height: props.modalDisplayData.length < 10 ? 'auto' : '65%',
    transition: "custom-from-bottom-transition",
    persistent: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(modalTitle)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, _toDisplayString(__props.operationOfficeName) + " " + _toDisplayString(props.operationOfficeName), 1),
          _createVNode(CopyButton, {
            copyText: copyedValue.value,
            modelValue: isCopied.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCopied).value = $event))
          }, null, 8, ["copyText", "modelValue"])
        ]),
        _createVNode(DisplayFailedList, {
          tripIdList: props.modalDisplayData
        }, null, 8, ["tripIdList"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_btn, {
          class: "d-flex justify-content-end close-btn",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(closeBtnName)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "height"]))
}
}

})